import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Vue from 'vue'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://e7f106136dbf4e19ac313bd75b049ebd@sentry.io/1455797',
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true
            })
        ]
    })
}
